import { SendEmailByTemplate } from 'api/Email/Email.api';
import { Config } from 'config';

/**
 * Sends an email notification intended for the developers to aid in debugging errors.
 * @param componentName The name of the relevant component. This appears in the email subject.
 * @param message String which appears in the body of the message.
 */
export const SendAppErrorEmail = (componentName: string, message: string = '') => {
    SendEmailByTemplate(
        Config.applicationErrorEmail,
        'ApplicationError',
        `Error in ${componentName}. (Env: ${process.env.REACT_APP_ENVIRONMENT || 'Unknown'})`,
        {
            message: message
        }
    );
};
